export default "__VITE_ASSET__Bg5t_HWD__"